<template>
  <div class="signup card">
    <h1>Let's create an account</h1><br>

    <p>Before you create your draft, we just need some basic information from you.</p><br>

    <div v-if="invitePending">
      <h4>Create an account and we'll get you added to the draft</h4>
      <br>
    </div>

    <form ref="form" @submit.prevent="signup">
      <input type="name" required maxlength="20" placeholder="Name" v-model="signupForm.name">

      <input type="email" required placeholder="Email" v-model="signupForm.email">

      <input
        type="password"
        minlength="7"
        required
        placeholder="Password"
        v-model="signupForm.password"
      >

      <br>

      <button type="submit" :disabled="running">Sign up</button><br><br>

      <div class="error" v-show="error">{{ error }}</div>

      <p>
        <span>Already have an account?</span>

        <router-link to="/login">
          Login
        </router-link>
      </p>

      <p>
        <span>By signing up, you agree to our</span>
        <router-link to="/tos">
          terms of use
        </router-link>
      </p>

      <p>
        Don't forget to download the apps to make picks from your phone.
      </p>

      <app-icons />
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AppIcons from '@/components/AppIcons';

export default {
  components: {
    AppIcons,
  },

  data() {
    return {
      signupForm: {
        name: '',
        email: '',
        password: '',
      },
      error: '',
      running: false,
    };
  },

  computed: {
    ...mapState({
      attemptedRoute: ({ auth }) => auth.attemptedRoute,
    }),

    invitePending() {
      return this.attemptedRoute && this.attemptedRoute.name === 'invite';
    },
  },

  methods: {
    signup() {
      if (!this.running) {
        this.running = true;

        this.$firebase.auth()
          .createUserWithEmailAndPassword(this.signupForm.email, this.signupForm.password)
          .then((user) => {
            this.createUser(user);
          })
          .catch((err) => {
            this.running = false;
            this.error = err.message;
          });
      }
    },

    createUser(user) {
      this.$store.dispatch('auth/CREATE_USER', { user, name: this.signupForm.name })
        .then(() => {
          this.$router.push('/handleLogin');
        });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>
  .signup {
    @include centerContainer;
  }

  .error {
    margin-bottom: $gp;
  }
</style>
